import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function FiltersIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="13.933" height="14.075" viewBox="0 0 13.933 14.075" {...props}>
      <defs>
        <style>
          {`.cls-2{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.75px}`}
        </style>
      </defs>
      <g id="Group_5994" transform="translate(-1084.878 -26.462)">
        <g id="Group_5993" transform="translate(520.82 -1088.179)">
          <circle id="Ellipse_4" cx="1.256" cy="1.256" r="1.256" class="cls-2" transform="translate(566.409 1115.516)"/>
          <circle id="Ellipse_5" cx="1.256" cy="1.256" r="1.256" class="cls-2" transform="translate(573.191 1120.406)"/>
          <circle id="Ellipse_6" cx="1.256" cy="1.256" r="1.256" class="cls-2" transform="translate(568.067 1125.329)"/>
          <g id="Group_5993-2" transform="translate(564.934 1116.705)">
            <path id="Line_461" d="M0 0L12.183 0" class="cls-2"/>
            <path id="Line_462" d="M0 0L12.183 0" class="cls-2" transform="translate(0 4.94)"/>
            <path id="Line_463" d="M0 0L12.183 0" class="cls-2" transform="translate(0 9.78)"/>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default FiltersIcon;


// WEBPACK FOOTER //
// ./src/components/icons/FiltersIcon.jsx